import MuxVideo from '@/components/MuxVideo'
import { createDataAttribute } from 'next-sanity'

export default function VideoBlock({autoplay, loop, showAudioToggle, video, documentId, _key}:any) {
	return (
		<div className="section"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>
			<MuxVideo
				playbackId={video?.asset?.playbackId}
				className={`block w-full h-full object-cover`}
				autoplay={autoplay}
				muted={autoplay}
				loop={loop}
				showAudioToggle={showAudioToggle}
			/>
		</div>
	)
}